import React, { useEffect } from 'react'
import TypesenseSearch from './sidebar/typesense-search'
import { useSelector, useDispatch } from 'react-redux'
import {
  selectDocumentViewerSidebarOpen,
  setDocumentViewerSidebarOpen,
} from '../redux/viewer-slice'
import SidebarToc from './sidebar/sidebar-toc'
import SidebarDefinitions from './sidebar/sidebar-definitions'
import { useParams } from 'react-router-dom'

const DocumentViewerSidebar: React.FC = () => {
  const documentViewerSidebarOpen = useSelector(selectDocumentViewerSidebarOpen)
  const dispatch = useDispatch()
  const { documentId } = useParams<{ documentId: string }>()

  useEffect(() => {
    if (!documentId) {
      dispatch(setDocumentViewerSidebarOpen(null))
    }
  }, [documentId, dispatch])

  return (
    <div
      className={`absolute right-full top-12 z-[39] max-h-[80vh] min-h-32 w-96 rounded-lg border border-[#dbdee3] bg-white shadow-lg overflow-hidden`}
    >
      {documentViewerSidebarOpen === 'search' && <TypesenseSearch />}
      {documentViewerSidebarOpen === 'toc' && <SidebarToc />}
      {documentViewerSidebarOpen === 'definitions' && <SidebarDefinitions />}
    </div>
  )
}

export default DocumentViewerSidebar
